import React, { useMemo } from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import useTemplateName from './useTemplateName';

export const useFormNameColumns = (flagEnabled) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { getTemplateName } = useTemplateName();
  return useMemo(() => {
    const columnWidth = flagEnabled ? 150 : 230;

    return {
      columnWidth,
      columns: flagEnabled
        ? [
            {
              header: T.translate('FORM_NAME'),
              accessorKey: 'name',
              minSize: columnWidth,
              size: columnWidth,
              cell: ({ getValue, row }) => {
                const templateName = getTemplateName(row?.original);
                return (
                  <OverflowTooltip>
                    {getValue() || templateName}
                  </OverflowTooltip>
                );
              },
            },
          ]
        : [],
    };
  }, [T, flagEnabled, getTemplateName]);
};
